// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

export const TableWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        maxHeight: '70vh',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
      }}
    >
      {children}
    </Box>
  );
};
